import { ApiResponse } from "../types/api";
import { User } from "../types/user";
import api from "./api";
import { API_ENDPOINTS } from "./endpoints";

class ProfileService {
    async getMe(): Promise<User> {
        try {
            const response = await api.get<ApiResponse<User>>(API_ENDPOINTS.PROFILE.GET);
            return response.data.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new ProfileService();